import React, { useEffect } from "react";
import { WorkShopJson } from "../data/WorkshopJson"; 
import AOS from "aos";
import "aos/dist/aos.css";
import { GiClick } from "react-icons/gi";

const Workshop = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div
      id="Workshops"
      className="p-0 m-0 min-h-screen bg-gradient-to-r from-[#0f2027] via-[#203a43] to-[#2c5364] text-white"
    >
      {/* Heading */}
      <h1 className="text-center text-3xl md:text-4xl lg:text-5xl font-extrabold pt-8 text-yellow-400 drop-shadow-lg">
        Workshops
      </h1>
      <p className="text-center text-gray-200 max-w-2xl mx-auto mt-3 text-lg">
        We are organizing exciting workshops on trending topics. Register now to
        enhance your skills and experience the best learning journey.
      </p>

      {/* Workshop Cards */}
      <div className="flex flex-wrap justify-center gap-8 mt-10">
        {WorkShopJson.map((workshop, index) => (
          <div
            key={index}
            data-aos="fade-up"
            data-aos-duration="900"
            data-aos-delay={index * 120}
            className="w-80 rounded-2xl shadow-2xl overflow-hidden 
                       bg-gradient-to-br from-[#ffecd2] to-[#fcb69f] 
                       text-gray-900 transform hover:scale-105 hover:shadow-yellow-400/50 transition-all duration-500"
          >
            <img
              src={workshop.image}
              alt={workshop.title}
              className="h-56 w-full object-cover rounded-t-2xl"
            />
            <div className="p-5 text-center">
              <h2 className="text-2xl font-bold text-indigo-800 drop-shadow-sm">
                {workshop.title}
              </h2>
              <p className="text-gray-700 text-sm mt-2">
                {workshop.price}
                <br />
                {workshop.Accommodation}
              </p>
              <h3 className="text-md font-bold mt-4 text-pink-600">
                {workshop.highlight}
              </h3>
              <ul className="text-gray-800 text-sm text-left list-disc pl-5 mt-2 space-y-1">
                {workshop.description.map((desc, i) => (
                  <li key={i}>{desc}</li>
                ))}
              </ul>
              <a
                href={workshop.pdfLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-5 px-6 py-2 text-white 
                           bg-gradient-to-r from-red-500 to-yellow-400 
                           rounded-full shadow-md hover:scale-105 
                           hover:shadow-lg transition-all duration-300 
                           flex items-center justify-center"
              >
                <GiClick className="mr-2" />
                Explore
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Register button */}
      <div className="flex justify-center text-xl font-bold mt-10 pb-10">
        <a
          className="min-w-[50%] text-center bg-gradient-to-r from-blue-500 to-purple-600 
                     text-white px-4 py-3 rounded-2xl hover:scale-105 
                     hover:shadow-xl hover:from-purple-600 hover:to-pink-500 
                     transition-all duration-500 animate-pulse"
          href="https://forms.gle/88Lzre56nVhUmzau8"
          target="_blank"
          rel="noopener noreferrer"
        >
          🚀 Click Here To Register For Workshop
        </a>
      </div>
    </div>
  );
};

export default Workshop;
